module.exports = __webpack_public_path__ + "static/Truck36-57a1d0329a16fd5de162eaac9eda371a.png";